export default __webpack_public_path__ + "static/media/failure.f9bfb652.svg";